export const load = () => ({
	title: 'Privacy Policy',
	showTitle: true,
});
